import React from "react";

function RawData() {
  return <div>You may see your Categorised Data Below </div>;
}

export default RawData;
